import React from 'react';
import styles from './index.module.scss';

const Warning = props => {
  return (
    <div className={styles['warning']}>
      <i className={'fa fa-warning mr-2'} />
      <div>
        {props.message}
      </div>
    </div>
  );
};

export default Warning;